import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, Outlet } from 'react-router-dom';
import { LayoutDashboard, AppWindow, Plus, Settings as SettingsIcon, LogOut, Menu, X, Globe } from 'lucide-react';
import { clearToken, adminMe } from '../../utils/adminApi';

const navItems = [
  { to: '/wp-admin', icon: LayoutDashboard, label: 'Dashboard', exact: true },
  { to: '/wp-admin/apps', icon: AppWindow, label: 'All Apps' },
  { to: '/wp-admin/apps/new', icon: Plus, label: 'Add New' },
  { to: '/wp-admin/settings', icon: SettingsIcon, label: 'Settings' },
];

const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    adminMe().catch(() => navigate('/wp-admin/login'));
  }, [navigate]);

  const logout = () => {
    clearToken();
    navigate('/wp-admin/login');
  };

  const isActive = (item) => {
    if (item.exact) return location.pathname === item.to;
    return location.pathname.startsWith(item.to);
  };

  return (
    <div className="min-h-screen bg-[#f0f0f1] flex">
      {/* Sidebar */}
      <aside
        className={`fixed lg:static inset-y-0 left-0 z-40 w-60 bg-[#1d2327] text-white transform transition-transform ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        }`}
      >
        <div className="px-4 py-4 border-b border-white/10 flex items-center justify-between">
          <Link to="/wp-admin" className="font-semibold text-lg">
            Admin <span className="text-blue-400">Panel</span>
          </Link>
          <button className="lg:hidden" onClick={() => setSidebarOpen(false)}>
            <X className="w-5 h-5" />
          </button>
        </div>
        <nav className="py-3">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item);
            return (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setSidebarOpen(false)}
                className={`flex items-center gap-3 px-4 py-2.5 text-sm transition-colors ${
                  active ? 'bg-[#2271b1] text-white' : 'text-gray-200 hover:bg-white/10'
                }`}
              >
                <Icon className="w-4 h-4" />
                {item.label}
              </Link>
            );
          })}
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-200 hover:bg-white/10"
          >
            <Globe className="w-4 h-4" /> View Site
          </a>
          <button
            onClick={logout}
            className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-200 hover:bg-white/10 mt-2 border-t border-white/10"
          >
            <LogOut className="w-4 h-4" /> Log Out
          </button>
        </nav>
      </aside>

      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/40 z-30 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-12 bg-white border-b border-gray-200 px-4 flex items-center justify-between">
          <button className="lg:hidden" onClick={() => setSidebarOpen(true)}>
            <Menu className="w-5 h-5" />
          </button>
          <div className="flex-1" />
          <div className="text-sm text-gray-600">Howdy, <span className="font-semibold text-gray-900">Admin</span></div>
        </header>
        <main className="flex-1 p-4 sm:p-6 max-w-6xl w-full mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
